"use client";
import { SectionPromo } from "@/components/shared/sections/SectionPromo";
import { InputSearch } from "@/components/form/InputSearch";
import { useDispatch } from "react-redux";
import { useRedirect } from "@/helpers/useRedirect";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { setSearchQuery } from "@/store/actions/faqActions";
import { UrlObject } from "url";
import { useAppSelector } from "@/store/store";
import s from "./SectionFAQPromo.module.scss";
import { FAQPageType } from "@/components/pages/faq/FAQPage";

type SectionFAQPromoProps = {
  type: FAQPageType;
};

export const SectionFAQPromo = ({ type }: SectionFAQPromoProps) => {
  const search = useAppSelector((state) => state.faq.searchQuery);
  const dispatch = useDispatch();
  const redirect = useRedirect();
  const pathname = usePathname();

  const searchRef = useRef<string>(search);
  searchRef.current = search;

  const [urlUpdating, setUrlUpdating] = useState(false);

  const handleSearch = (value: string) => {
    dispatch(setSearchQuery(value));
    if (urlUpdating) return;

    setUrlUpdating(true);
    setTimeout(() => {
      const newUrlParams: UrlObject = {
        pathname: pathname,
      };

      if (searchRef.current) {
        newUrlParams.query = {
          search: searchRef.current,
        };
      }

      redirect(
        newUrlParams.pathname + (newUrlParams?.query?.search ? `?search=${newUrlParams.query.search}` : "")
      );
      setUrlUpdating(false);
    }, 2000);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    dispatch(setSearchQuery(params.get("search") || ""));
  }, [dispatch]);

  return (
    <SectionPromo
      heading="FAQ"
      image={{
        src: "/img/text-question.png",
        width: 110,
        height: 100,
      }}
      breadcrumbs={[
        { position: 1, name: "Main", item: "/" },
        { position: 2, name: "FAQ", item: `/faq-${type}` },
      ]}
    >
      <InputSearch
        searchTerm={search}
        handleSearch={handleSearch}
        placeholder="What do you want to know?"
        className={s.searchInput}
      />
    </SectionPromo>
  );
};
